const EmptySelect = ({options, selectedValue}) =>{
    return <select value={""} className="form-control" disabled>
    <option>Select </option>
    {options.map((videoDevice, index) => {
        return (selectedValue === videoDevice.deviceId)?<option key={`vidoption${index}`} selected value={videoDevice.deviceId}>{videoDevice.label} </option>:<option key={`vidoption${index}`} value={videoDevice.deviceId}>{videoDevice.label}</option>;   
    })}
</select>
}
export default EmptySelect;